export default __webpack_public_path__ + "static/media/Group256.9c4acae5.png";